var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2067_2499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2234 0.25293H1.77187C0.792187 0.25293 0 1.02637 0 1.98262V22.5186C0 23.4748 0.792187 24.2529 1.77187 24.2529H22.2234C23.2031 24.2529 24 23.4748 24 22.5232V1.98262C24 1.02637 23.2031 0.25293 22.2234 0.25293ZM7.12031 20.7045H3.55781V9.24824H7.12031V20.7045ZM5.33906 7.6873C4.19531 7.6873 3.27188 6.76387 3.27188 5.6248C3.27188 4.48574 4.19531 3.5623 5.33906 3.5623C6.47813 3.5623 7.40156 4.48574 7.40156 5.6248C7.40156 6.75918 6.47813 7.6873 5.33906 7.6873ZM20.4516 20.7045H16.8937V15.1357C16.8937 13.8092 16.8703 12.0982 15.0422 12.0982C13.1906 12.0982 12.9094 13.5467 12.9094 15.042V20.7045H9.35625V9.24824H12.7687V10.8139H12.8156C13.2891 9.91387 14.4516 8.96231 16.1813 8.96231C19.7859 8.96231 20.4516 11.3342 20.4516 14.4186V20.7045Z",
    fill: "#98A2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2067_2499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.25293)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon2);
export default __webpack_public_path__ + "static/media/linkedinIcon2.a95a0b7ac902a4d9ff63f590b8c2119e.svg";
export { ForwardRef as ReactComponent };